// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff049cd2","239":"732c8591","453":"24523b4b","455":"d74871a4"}[chunkId] + ".chunk.js";
};